import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  contentDisplay: {
    display: 'flex',
    padding: '0 10px',
    alignItems: 'center',
    gap: '8px',
  },
  previewIcon: {
    '& svg': {
      fill: semanticColors.foreground.secondary
    }
  },
  activePreview: {
    '& svg': {
      fill: semanticColors.foreground.action
    }
  },
  previewIconButton: {
    padding: 0,
    borderRadius: '4px',
  },
  formatsPanel: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  iconButton: {
    padding: 0,
    borderRadius: '4px',
  },
  popoverPaper: {
    padding: '8px',
  },
  formatThumbnailButton: {
    all: 'unset',
    cursor: 'pointer',
    display: 'inline-block',
  },
});
